import React from 'react'

import HowToUse from './how-to-use'
import SupportedFeatures from './supported-features'
import SecurityAndCompliance from './security-and-compliance'

export { default as About } from './about'
// export { default as RequiresExternalSetupInformation } from './requires-external-setup-information'

export const Overview = props => (
    <>
        <HowToUse {...props} />
        <SupportedFeatures {...props} />
        <SecurityAndCompliance {...props} />
    </>
)